module.exports = __webpack_public_path__ + "img/s3.f8247d0c.png";